import { useRouter } from 'next/router';
import { useCallback } from 'react';

// Utility to extract only the string after hash
const extractHash = (url: string): string => {
  return url.split('#')[1] ?? '';
};

/**
 * Custom hook for utilizing hash fragment in the URL
 *
 * Usage is as below
 * hash: current hash value (not contain #)
 * setHash: update current hash
 * ```
 * const [hash, setHash] = useHash()
 * ```
 */
const useHash = (options?: {
  leaveHistory?: boolean;
}): [string, (newHash: string) => void] => {
  const router = useRouter();

  const hash = extractHash(router.asPath);

  const setHash = useCallback((newHash: string) => {
    if (options && options.leaveHistory) {
      router.push({ hash: newHash }, undefined, { shallow: true });
    } else {
      router.replace({ hash: newHash }, undefined, { shallow: true });
    }
  }, []);

  return [hash, setHash];
};

export default useHash;
